import {useProductDetailsQuery} from "./useProductDetailsQuery";
import {EnvironmentalModel} from "../models/view/environmentalModel";

export const useEnvironmentalClaimsQuery = () => {
    const {model: {environmental}} = useProductDetailsQuery() ?? {environmental: {}};
    return {model: new EnvironmentalModel(environmental)};
}